// extracted by mini-css-extract-plugin
module.exports = {"categoryHeader":"style_categoryHeader__3nnh1","categoryContainer":"style_categoryContainer__24j6n"};